<app-header></app-header>
<div class="breadcrumb">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <span><a class="cursor-link" (click)="goToTheme()">Preview</a> > Education > Experience > Skills > Languages > Hobbies > <strong>Accomplishments</strong></span>
      </div>
    </div>
  </div>
</div>
<div class="addAccomplistments">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="">
          <h2>Add Accomplishments</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="tinyMCE">
          <editor [init]="utilService.editorConfig"  [(ngModel)]="resume.accomplishments"></editor>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="tips">
          <h1><span class="icon icon-help"></span> Tips</h1>
          <p>Add the accomplishment in its minimilistic form and show your diverse set of skills. You can add in the following ways:</p>
          <ul>
            <li>Awarded as the best fine arts club representative in IIT Delhi</li>
            <li>Winner of Inter IIT Dance Competition</li>
          </ul>
        </div>
        <!--<div class="titleBody">
          <div class="titleAdd">
            <div class="titleAdd__plus" *ngFor="let desc of descs" (click)="append(resume, desc)">
              <div class="titleAdd__text"><span>Add</span></div>
              <div class="titleAdd__body" [innerHTML]="desc"></div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-4">
        <div class="addAccomplistments__buttons">
          <button class="btn btn-default" routerLink="/resume/hobbies">Back</button>
        </div>
      </div>
      <div class="col-sm-6 col-8 text-right">
        <div class="addAccomplistments__buttons">
          <button class="btn btn-default" routerLink="/resume/certificates">Skip</button>
          <button class="btn btn-primary" (click)="save()">Save &amp; Next</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
